import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect } from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';

class VerifyMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        LOADING: true,
        OTP: false 
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    let err = 0;
    if ($('#frmVerifyMobile')[0].checkValidity() === false) {
        e.preventDefault();
        e.stopPropagation();
        err++;
    }
    $('#frmVerifyMobile')[0].classList.add('was-validated');

    if(err==0)
    {
      $('#submitLoading').css('display','block');

      const method = "POST";
        const body = new FormData(this.form);
        //console.log(body);
        var that = this;
        fetch("https://m.donedelivery.in/api/customerverifymobile_api.php", { method, body })
        .then(function (response) {
            //console.log(response);
            return response.json();
        })
        .then(function (result) {
            //console.log(result);
            let notify = '';
            if(result.err!='')
            {
                if(result.err=='1') notify = 'Mobile Field is Empty';
                else if(result.err=='2') notify = 'No Such User Exist';
                else if(result.err=='3') notify = 'Invalid Access Detected';
                else if(result.err=='4') notify = 'Mobile Area Code Field is Empty';
            }

            let otp_sent = false;
            if(result.otp_sent=='Y')
            {
              otp_sent = true;
              let customer = result.customer;
              let mobileno = result.mobileno;
              let emailid = result.emailid;

              if(customer!='' && customer!=undefined)
              {
                localStorage.setItem('tempData',customer);
                if(mobileno!='') localStorage.setItem('tempREG',mobileno);
                if(emailid!='') localStorage.setItem('tempEMAIL',emailid);
              }
            }

            that.setState({ Notifications: notify, OTP:otp_sent });
            $('#submitLoading').css('display','none');
            if(notify!='')
                $('#ModalAlert').modal('show');
      });
    }
  }

  componentWillMount() {
    let mount = $("div").hasClass("modal-backdrop");
    if(mount==true)
    {
      $('body').removeClass('modal-open');
      $(".modal-backdrop").remove();
      //window.location.reload(true);
    }
  }

  componentDidMount() {
    this.setState({ LOADING:false });
  }

  render() { 

    if (this.state.OTP) {
			return (<Redirect to={'/smsverifyMobile'} />)
    }
    
    let AppHeaderClass = 'appHeader bg-dark text-light';
    let AppHeaderLeft = 'showLINK';
    let AppHeaderLeftLink = '/cart';
    let AppHeaderTitle = 'Verify Account';
    let AppHeaderRight = '';
    let AppHeaderRightLink = '';
    let AppHeaderSearch = '';

    return (
      <div>
        {this.state.LOADING && <Loader /> }
        <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
        <div id="appCapsule">
          <div className="login-form mt-5 pt-3 pr-3 pl-3">
            <div className="section">
              <h4 className="size-19">Type your registered mobile no to verify your account</h4>
            </div>
            <div className="section mt-2 mb-5">
              <form name="frmVerifyMobile" id="frmVerifyMobile" ref={el => (this.form = el)} onSubmit={this.handleSubmit} className="needs-validation" noValidate>
                <input type="hidden" value="VERIFY_MOBILE" className="form-control" name="mode" id="mode" required />
                <div className="form-group boxed">
                  <div className="wid-20">
                    <div className="input-wrapper">
                      <label className="label" htmlFor="txtusercode">Code</label>
                      <input type="text" className="square-inputbox form-control" name="txtusercode" id="txtusercode" required minLength="3" maxLength="6" defaultValue='+91' autoComplete="off"/>
                      <i className="clear-input">
                        <ion-icon name="close-circle"></ion-icon>
                      </i>
                      <div className="valid-feedback">&nbsp;</div>
                      <div className="invalid-feedback">Please enter your area code.</div>
                    </div>
                  </div>
                  <div className="wid-80-VM"> 
                    <div className="input-wrapper">
                      <label className="label" htmlFor="txtusermobile">Mobile</label>
                      <input type="text" className="square-inputbox form-control" name="txtusermobile" id="txtusermobile" required minLength="10" maxLength="11" pattern="[0-9]{10}" autoComplete="off"/>
                      <i className="clear-input">
                        <ion-icon name="close-circle"></ion-icon>
                      </i>
                      <div className="valid-feedback">&nbsp;</div>
                      <div className="invalid-feedback">Please enter your 10 digit mobile no.</div>
                    </div>
                  </div>
                  <div className="clear"></div>
                </div>
                <div className="form-button-group pl-4 pr-4 bg-common">
                  <button type="submit" className="lt-space1 text-upper btn btn-danger btn-block square btn-md">
                    <span className="spinner-border spinner-border-sm mr-05" id="submitLoading" style={{display: 'none'}} role="status" aria-hidden="true"></span>
                    Submit</button>
                </div>
              </form>
            </div>
            <div className="modal fade dialogbox" id="ModalAlert" data-backdrop="static" tabIndex="-1" role="dialog">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-icon text-danger">
                    <ion-icon name="close-circle"></ion-icon>
                  </div>
                  <div className="modal-body"> 
                    {this.state.Notifications} 
                  </div>
                  <div className="modal-footer">
                    <div className="btn-inline"> 
                      <button type="button" className="btn" data-dismiss="modal">Ok</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
  
export default VerifyMobile;


// WEBPACK FOOTER //
// ./src/components/VerifyMobile.js